import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'main' ];

  connect(){
    this.element.modal = this;
  }

  open(e) {
    e.preventDefault();
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    this.mainTarget.classList.add('--open');
  }

  close(e) {
    e.preventDefault();
    // Unlock body scroll
    document.body.style.overflow = '';
    this.mainTarget.classList.remove('--open');
  }

  handleBackgroundClick(e) {
    if ( e.target === e.currentTarget ){
      this.close(e);
    }
  }

  disconnect() {
    // Ensure body scroll is unlocked when controller is removed
    document.body.style.overflow = '';
  }
}
